"use strict";

window.addEventListener('load', () => {
      // 監視対象の要素を取得
      const inviewElements = document.querySelectorAll('.js-inview');
      const showElements = document.querySelectorAll('.js-show');

      // IntersectionObserverのオプション設定
      const observerOptions = {
            threshold: 0.3 // 要素が30%表示されたら検出
      };

      // Intersection Observerのコールバック
      const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                  if (entry.isIntersecting) {
                        if (entry.target.classList.contains('js-inview')) {
                              entry.target.classList.add('is-inview');
                        } else {
                              entry.target.classList.remove('is-inview');
                        }

                        if (entry.target.classList.contains('js-show')) {
                              entry.target.classList.add('is-show');
                        } else {
                              entry.target.classList.remove('is-show');
                        }
                  }
            });
      }, observerOptions);

      // 全ての対象要素を監視対象に登録
      inviewElements.forEach(element => {
            observer.observe(element);
      });
      showElements.forEach(element => {
            observer.observe(element);
      });
});

